<template><div><h1>为什么使用 .vue 源码分发而不是 js 文件</h1>
<p>代码冗余，无法在构建时优化，出错时难以跟踪，作为组件维护者可能要打包多份代码出来满足不同需求(压缩版，未压缩，不同语言版)。在webpack中如果不加配置还会被多次打包。</p>
<p>整体打包成一个js和一个css在移动端属于严重浪费，降低体验和性能。</p>
<p>就上面的问题来说，源码分发的方式完美解决。</p>
<p>源码分发的最大好处是可以实现源码编译时处理，这也是 <code>vux-loader</code> 的用处。</p>
</div></template><script>
export default {
  head: {"title":"为什么使用 .vue 源码分发而不是 js 文件 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-use-vue-file-for-distribution-55.vue?72bddaba